import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {Button} from '@material-ui/core';
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../_metronic/_partials/controls';
import SymptomModel from '../../models/Symptom';
import DiagnoseModel from '../../models/Diagnose';
import DiseaseModel from '../../models/Disease';
import ButtonLink from '../../components/common/ButtonLink';
import { DataTableLocal as DataTable } from '../../components/common/DataTable';
import { fetchDiseaseList } from '../../../redux/disease/list';
import _ from 'lodash';
import { CSVLink } from 'react-csv';

const ExportDiagnosis = () => {
  const [records, setRecords] = useState([]);
  const [rowExportX, setRowExportX] = useState([]);
  const [rowExportY, setRowExportY] = useState([]);
  const [activeDiseases, setActiveDiseases] = useState([]);
  const initialize = async () => {
    try {
      const result = await DiagnoseModel.getAllRecords();
      console.log('records', result);

      const result2 = await SymptomModel.getAllActiveOptionIds();
      
      const result3 = await DiseaseModel.getAllActiveDiseaseIds();

      setActiveDiseases(result3)

      console.log('options', result2, result3);

      let rowsX = []
      let rowsY = []
      rowsX.push(result2)
      rowsY.push(result3)

      if(result) {
        result.forEach(el => {
          let arrSymptoms = []
          let arrDiseases = []

          el.diagnose_record_symptoms?.map(el => {
            arrSymptoms.push(el.symptom_detail_option_id)
          })
          //console.log("cek", arrSymptoms)

          el.diagnose_result_disease?.map(el => {
            arrDiseases.push(el.disease_id)
          })

          let rowX = []
  
          result2.forEach(el => {
            if(arrSymptoms.includes(el)) {
              rowX.push(1)
            } else {
              rowX.push(0)
            }
          })

          let rowY = []

          result3.forEach(el => {
            if(arrDiseases.includes(el)) {
              rowY.push(1)
            } else {
              rowY.push(0)
            }
          })

          rowsX.push(rowX)
          rowsY.push(rowY)
        })
      }
 
      //console.log("rows", rows)
      setRowExportX(rowsX)
      setRowExportY(rowsY)

      setRecords(result);
    } catch (e) {
      console.log('failed to retrive', e);
    }
  };
  useEffect(() => {
    initialize();
    // dispatch(fetchDiseaseList());
  }, []);

  return (
    <Card>
      <CardHeader title="Diagnose records">
        <CardHeaderToolbar>
          {/* <ButtonLink link="/disease/add" variant="contained" color="primary">
            Export
          </ButtonLink> */}
          <CSVLink
            filename={
              "X_train.csv"
            }
            data={rowExportX}
          >
            Download X
          </CSVLink>
          <CSVLink
            filename={
              "Y_train.csv"
            }
            data={rowExportY}
          >
            Download Y
          </CSVLink>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
      
      </CardBody>
    </Card>
  );
};

export default ExportDiagnosis;
